import type { ProductoOtorgado } from '../organisms/Risk/CreditoMaximo/CreditoMaximo.types';
import type { applicationData } from '../types/interfaces';

const parseAmountValue = (raw: string | number): number => {
  const value = typeof raw === 'string' ? parseFloat(raw) : Number(raw);
  return Number.isFinite(value) ? value : 0;
};

const parseAssetCount = (raw: string | number | undefined | null): number | undefined => {
  if (raw === undefined || raw === null || raw === '' || raw === '-') {
    return undefined;
  }
  const parsed = typeof raw === 'string' ? parseInt(raw, 10) : Number(raw);
  return Number.isFinite(parsed) && Number.isInteger(parsed) ? parsed : undefined;
};

const resolveAssetCode = (raw: string | undefined): string | undefined => {
  const trimmed = raw?.trim();
  return trimmed ? trimmed : undefined;
};

/** Maps crédito máximo product to approved_products payload (committee close). */
export const mapProductoOtorgadoToApprovedProduct = (
  product: ProductoOtorgado,
): applicationData => {
  const assetCode = resolveAssetCode(product.asset_code);
  const assetCount = parseAssetCount(product.cantidad_otorgada);

  const mapped: applicationData = {
    id: product.product_id,
    product_line_code: product.product_line_code,
    amount: {
      currency_code: product.currency_code,
      value: parseAmountValue(product.monto_otorgado),
    },
  };

  if (assetCode) {
    mapped.asset_code = assetCode;
    mapped.has_assets = true;
    if (assetCount !== undefined) {
      mapped.asset_count = assetCount;
    }
  }

  return mapped;
};

/** Maps solicitud product to approved_products payload when crédito máximo is unavailable. */
export const mapApplicationProductToApprovedProduct = (
  product: applicationData,
): applicationData => {
  const assetCode = resolveAssetCode(product.asset_code);
  const assetCount = parseAssetCount(product.asset_count);

  const mapped: applicationData = {
    id: product.id,
    product_line_code: product.product_line_code,
    amount: {
      currency_code: product.amount.currency_code,
      value: parseAmountValue(product.amount.value),
    },
  };

  if (assetCode) {
    mapped.asset_code = assetCode;
    mapped.has_assets = product.has_assets ?? true;
    if (assetCount !== undefined) {
      mapped.asset_count = assetCount;
    }
  }

  return mapped;
};
